"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var router_history_1 = require("@reverbdotcom/commons/dist/cms/lib/router_history");
var api_request_1 = require("../../api_request");
var site_search_1 = require("./site_search");
var url_helpers_1 = require("../../shared/url_helpers");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var rql_1 = require("../../../schemas/rql");
exports.COMPONENT_NAME = 'search_bar';
var SELECT_INTERACTION = 'select';
var SUBMIT_INTERACTION = 'submit';
var ReverbSiteSearchController = /** @class */ (function () {
    function ReverbSiteSearchController() {
    }
    ReverbSiteSearchController.checkForRedirect = function (query) {
        var res = api_request_1.V3.get(url_helpers_1.default.redirectsPath, { query: query });
        res.fail(function (_xhr, status, err) {
            throw new Error("failed to check for redirect - status: " + status + ", err: " + err);
        });
        return res;
    };
    ReverbSiteSearchController.navigateWindow = function (href) {
        window.location.href = href;
    };
    ReverbSiteSearchController.redirectTo = function (url, trackingParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var event, clientSide;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event = tslib_1.__assign({ url: url, componentName: exports.COMPONENT_NAME }, trackingParams);
                        return [4 /*yield*/, core_link_1.shouldClientSideResolve(url)];
                    case 1:
                        clientSide = _a.sent();
                        event.mParticleInteraction = {
                            eventName: mparticle_tracker_1.MParticleEventName.SiteSearch,
                            position: trackingParams.position,
                            suggestionId: String(trackingParams.entityId || ''),
                            suggestionType: trackingParams.context.type,
                            suggestionQuery: trackingParams.context.query,
                            suggestionCount: lodash_1.get(trackingParams, 'context.suggestions.length', 0),
                            interactionType: trackingParams.interactionType,
                            targetUrl: url,
                        };
                        tracker_1.trackInteraction(event);
                        if (clientSide) {
                            router_history_1.default.push(url);
                        }
                        else {
                            ReverbSiteSearchController.navigateWindow(url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReverbSiteSearchController.selectSuggestion = function (suggestion, suggestions, lastTypedValue) {
        if (lastTypedValue === void 0) { lastTypedValue = ''; }
        if (suggestion.type === site_search_1.RECENT_SEARCH) {
            ReverbSiteSearchController.submitRecentQuery(suggestion, suggestions, lastTypedValue);
            return;
        }
        var trackingEvent = {
            interactionType: SELECT_INTERACTION,
            position: suggestion.position,
            entityId: lodash_1.get(suggestion, 'completion.id'),
            context: {
                fullTextQuery: suggestion.value,
                type: suggestion.type,
                query: lastTypedValue,
                scope: suggestion.context,
                suggestions: ReverbSiteSearchController.suggestionValues(suggestions),
            },
        };
        if (rql_1.reverb_search_CompletionType[suggestion.type] || suggestion.type === site_search_1.SALE_SUGGESTION_TYPE) {
            ReverbSiteSearchController.redirectTo(suggestion.url, trackingEvent);
            return;
        }
        var uri = new URL(suggestion.url);
        var hostlessUrl = suggestion.url.replace(uri.origin, '');
        if (suggestion.context) {
            ReverbSiteSearchController.redirectTo(hostlessUrl, trackingEvent);
        }
        else {
            ReverbSiteSearchController.checkForRedirect(suggestion.value)
                .then(function (resp) {
                return ReverbSiteSearchController.redirectTo(resp.redirect || hostlessUrl, trackingEvent);
            });
        }
    };
    ReverbSiteSearchController.submitRecentQuery = function (suggestion, suggestions, lastTypedValue) {
        if (lastTypedValue === void 0) { lastTypedValue = ''; }
        var query = suggestion.value;
        var path = url_helpers_1.default.marketplaceQuery(query);
        var trackingEvent = {
            interactionType: SELECT_INTERACTION,
            position: suggestion.position,
            context: {
                fullTextQuery: query,
                type: site_search_1.RECENT_SEARCH,
                query: lastTypedValue,
                suggestions: ReverbSiteSearchController.suggestionValues(suggestions),
            },
        };
        ReverbSiteSearchController.checkForRedirect(query).then(function (resp) {
            ReverbSiteSearchController.redirectTo(resp.redirect || path, trackingEvent);
        });
    };
    ReverbSiteSearchController.submitQuery = function (query, suggestions, lastTypedValue) {
        if (lastTypedValue === void 0) { lastTypedValue = ''; }
        var path = url_helpers_1.default.marketplaceQuery(query);
        var trackingEvent = {
            interactionType: SUBMIT_INTERACTION,
            context: {
                fullTextQuery: query,
                query: lastTypedValue,
                suggestions: ReverbSiteSearchController.suggestionValues(suggestions),
            },
        };
        ReverbSiteSearchController.checkForRedirect(query).then(function (resp) {
            ReverbSiteSearchController.redirectTo(resp.redirect || path, trackingEvent);
        });
    };
    ReverbSiteSearchController.suggestionValues = function (suggestions) {
        return suggestions ? suggestions.map(function (s) { return s.value; }) : [];
    };
    return ReverbSiteSearchController;
}());
exports.default = ReverbSiteSearchController;
//# sourceMappingURL=reverb_site_search_controller.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/reverb_site_search_controller.js
// module id = lNEK
// module chunks = 20 21